<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Produtos e Serviços
              <TotalRegisters :total="itemsTableData.total" totalText="produtos e serviços" />
            </h4>

            <div class="d-flex align-items-center">
              <button class="btn btn-info btn-sm" @click="(visibilityStates.create = true), loadClasses()">Adicionar Produto ou Serviço</button>
            </div>
          </div>

          <Table :tableData="itemsTableData" :data="items" :columns="['id', 'name', 'type', 'createdAt', 'updatedAt', 'actions']" :actions="['edit']" @pagechanged="onPageChange" @openEditModal="openEditModal"> </Table>

          <ListLoader v-if="itemsTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!itemsTableData.loading && itemsTableData.error"></Error>
          <Empty v-if="!itemsTableData.loading && !itemsTableData.error && items.length === 0"></Empty>
        </card>
      </div>
    </div>

    <!-- Modal Edit -->
    <Modal v-model="visibilityStates.edit" action="Salvar" :scroll="true" title="Editar Item" @closeModal="clearEditModal()" @confirmAction="updateItem(item, 'edit')">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" hidden class="form-control" v-model="item.id" />
          <input type="text" class="form-control" v-model="item.name" />
        </div>

        <div class="form-group">
          <label>Tipo</label>
          <treeselect v-model="item.type" :options="itemTypes" :normalizer="normalizer" />
        </div>

        <div class="form-group">
          <label>Classes</label>
          <treeselect v-model="item.classes" :multiple="true" value-format="object" :options="classes" :flat="true" :limit="6" :limitText="(count) => `e ${count} outras classes`" :normalizer="normalizer" />
        </div>

        <div class="form-group">
          <label>Logo <span style="font-size: 12px; color: rgba(255, 255, 255, 0.8)">(Tamanho recomendado: 600x400)</span></label>
          <div v-if="item.icon_name">
            <img ref="file" style="max-width: 100px" :src="item.icon_url" />
          </div>
          <button type="button" class="mt-3 d-block btn btn-primary float-left" @click="$refs.file.click()">Upload da Imagem</button>
          <input style="visibility: hidden" type="file" id="file" ref="file" v-on:change="handleFileUpload($event, 'edit')" />
        </div>
      </template>
    </Modal>

    <!-- Modal Add -->
    <Modal v-model="visibilityStates.create" :error="createError" :scroll="true" action="Salvar" title="Adicionar novo Item" @closeModal="clear(), (visibilityStates.create = false)" @confirmAction="createItem(newItem)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="newItem.name" placeholder="Ex: Telefonia móvel" />
        </div>

        <div class="form-group">
          <label>Tipo</label>
          <treeselect v-model="newItem.type" :options="itemTypes" :normalizer="normalizer" />
        </div>

        <div class="form-group">
          <label>Classes</label>
          <treeselect v-model="newItem.classes" placeholder="Selecione as classes do item" :multiple="true" value-format="object" :options="classes" :flat="true" :normalizer="normalizer" />
        </div>

        <div class="form-group">
          <label>Logo <span style="font-size: 12px; color: rgba(255, 255, 255, 0.8)">(Tamanho recomendado: 600x400)</span></label>
          <div v-if="item.image">
            <img class="mb-3" style="max-width: 100px" :src="item.imageDetails.location" />
            <input type="text" class="form-control" :placeholder="item.imageDetails.location" />
          </div>
          <div class="d-flex align-items-center">
            <button v-if="!item.image" type="button" class="mt-3 d-block btn btn-primary" style="max-height: 45px" @click="$refs.file.click($event)">Upload da Imagem</button>
            <img class="float-right w-25 ml-4" id="preview" v-if="url" :src="url" />
          </div>
          <input type="file" ref="file" @change="onFileChange($event)" />
          <div class="mt-3">Arquivo Selecionado: {{ newFile ? newFile.name : '' }}</div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Empty from '@/components/Common/Empty';
import Modal from '@/components/Modal/Modal';
import Table from '@/components/Common/Table';
import TotalRegisters from '@/components/Common/TotalRegisters';
import Treeselect from '@riophae/vue-treeselect';
import api from '@/api.js';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    Empty,
    Modal,
    Table,
    TotalRegisters,
    Treeselect,
  },
  data() {
    return {
      temporaryImage: null,
      visibilityStates: {
        create: false,
        edit: false,
      },
      newItem: {
        name: '',
        type: 'product',
        classes: [],
      },
      itemTypes: [
        {
          id: 'product',
          name: 'Produto',
        },
        {
          id: 'service',
          name: 'Serviço',
        },
      ],
      file: '',
      newFile: '',
      url: null,
    };
  },
  computed: {
    items() {
      return this.$store.getters['items/getItems'];
    },
    itemsTableData() {
      return this.$store.getters['items/getItemsTableData'];
    },
    item() {
      return this.$store.getters['items/getItem'];
    },
    createError() {
      return this.$store.getters['items/getCreateError'];
    },
    classes() {
      return this.$store.getters['classes/getAllClasses'];
    },
  },
  methods: {
    createItem: async function (payload) {
      const itemId = await this.$store.dispatch('items/create', payload);

      await api.patch(`/items/icons/${itemId}`, this.temporaryImage, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      this.temporaryImage = null;
      this.clearFileAndUrl();

      if (this.createError === '') {
        this.visibilityStates.create = false;
        this.clear();
      }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    onPageChange(page) {
      this.$store.dispatch('items/setPage', page);
    },
    clearFileAndUrl() {
      this.url = null;
      this.file = '';
      this.newFile = '';
    },
    clear() {
      Object.assign(this.$data.newItem, this.$options.data().newItem);
      this.clearFileAndUrl();
    },
    loadClasses: async function () {
      await this.$store.dispatch('classes/getAllClasses');
    },
    openEditModal: async function (id) {
      this.loadClasses();
      await this.$store.dispatch('items/getItemById', id);
      this.visibilityStates.edit = true;
    },
    updateItem: async function (params, type) {
      this.submitFile(type);
      let payload = {
        id: params.id,
        params: {
          name: params.name,
          type: params.type,
          classes: params.classes.map((s) => ({
            id: s.id,
          })),
        },
      };
      await this.$store.dispatch('items/update', payload);
      this.visibilityStates.edit = false;
    },
    clearEditModal() {
      this.visibilityStates.edit = false;
      this.clearFileAndUrl();
      this.item.icon_url = '';
    },
    handleFileUpload: async function (e) {
      const localFile = e.target.files[0];
      this.url = URL.createObjectURL(localFile);
      this.item.icon_url = this.url;
      this.file = this.$refs.file.files[0];
    },
    onFileChange(e) {
      const localFile = e.target.files[0];
      this.url = URL.createObjectURL(localFile);
      this.file = this.$refs.file.files[0];
      const imageName = this.file.name.replace(/\s+/g, '_');
      this.newFile = new File([this.file], imageName, { type: this.file.type });
    },
    submitFile: async function (type) {
      let formData = new FormData();
      formData.append('image', this.newFile);
      if (type === 'edit') {
        const res = await api.patch(`items/icons/${this.item.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        await this.$store.dispatch('items/getItemById', this.item.id);
      }

      if (type === 'add') {
        this.temporaryImage = formData;
      }
    },
  },
  mounted() {
    this.$store.dispatch('items/resetPagination');
  },
};
</script>
